import AdservioIcon from '@src/assets/icons/adservio.svg';
import React, { useEffect, useState } from 'react';

export const AdvervioLogin = ({ width }) => {
  const [returnUrl, setReturnUrl] = useState();

  useEffect(() => {
    const origin = window.location.origin;
    setReturnUrl(`${origin}/adservio`);
  }, []);

  return (
    <div className="adservio" style={{ width: width }}>
      <a
        className="adservio__btn"
        href={`https://www.adservio.ro/oauth2/authorize?_lang=en&response_type=code&client_id=mokosi&redirect_uri=${returnUrl}`}
      >
        Autentificare cu <AdservioIcon />
      </a>
    </div>
  );
};
